import React from "react";
import { SeriesTableProps, SeriesTableState } from "./models";


import DeleteIcon from '@mui/icons-material/Delete';
import { Box, IconButton, Stack, Typography } from "@mui/material";

import type { MRT_ColumnDef } from 'material-react-table';
import MaterialReactTable from 'material-react-table';

import EditIcon from "@mui/icons-material/Edit";

import { t } from "@lingui/macro";

import { ConfirmModal } from "commons/modal/confirm-modal";
import { ContentDescription, Series } from "models";
import { Link } from "react-router-dom";
import { selectDescriptionByLanguage } from "utils";


export class SeriesTable extends React.Component<SeriesTableProps, SeriesTableState> {
    private tableColumns: MRT_ColumnDef[];

    public constructor(props: any) {

        super(props)

        this.state = {
            openConfirmModal: false,
            seriesToDelete: ""
        }

        this.tableColumns = [
            {
                header: t({
                    id: "st-table-col-title",
                    message: "Nome Serie"
                }),
                accessorKey: "title",
                Cell: ({ cell, row }) => {
                    return (
                        <Typography>
                            {selectDescriptionByLanguage(cell.getValue<ContentDescription[]>(), "-1")}
                        </Typography>
                    );
                }
            },
        ];
    }

    private openConfirmModal = (id: string): void => {
        this.setState(() => ({
            openConfirmModal: true,
            seriesToDelete: id
        }))
    }

    private cancelConfirmModalCallback = (): void => {
        this.setState(() => ({
            openConfirmModal: false,
            seriesToDelete: ""
        }))
    }

    private acceptConfirmModal = (): void => {
        this.setState(() => ({
            openConfirmModal: false,
        }))
        this.deleteSeries()
    }

    private deleteSeries = (): void => {
        this.props.deleteSeries(this.state.seriesToDelete);
        this.setState(() => ({
            seriesToDelete: ""
        }))

    }

    private getIdValue = (row: any): string => {
        return row.original.id
    }

    private openEditModal = (series: any) => {
        this.props.openEditSeriesTable(series as Series);
    }

    private handlePageChange = (updateFn: any) => {
        let newPagination = updateFn(this.props.pagination);
        this.props.updatePaginationCallBackFn(newPagination);
    }

    render() {
        return (
            <>
                <Box style={{ maxWidth: '100%' }}>
                    <MaterialReactTable
                        columns={this.tableColumns}
                        rowCount={this.props.totalSeriesCount}
                        pageCount={Math.ceil(this.props.totalSeriesCount / this.props.pagination.pageSize)}
                        data={this.props.seriess}
                        enableRowSelection={false}
                        enableColumnOrdering={false}
                        enableColumnActions={false}
                        enableGlobalFilter={false}
                        enableFilters={false}
                        muiTableHeadCellProps={{
                            sx: {
                                color: "white",
                                backgroundColor: process.env.REACT_APP_PRIMARY_COLOR
                            }
                        }}
                        displayColumnDefOptions={{
                            'mrt-row-actions': {
                                header: ""
                            }
                        }}
                        enableRowActions
                        positionActionsColumn="last"
                        renderRowActions={({ row }) => (
                            <Stack direction={"row"} display={"flex"} justifyContent={"right"} >
                                <Link to={`/backoffice/edit-series/${this.getIdValue(row)}`}>
                                    <IconButton>
                                        <EditIcon />
                                    </IconButton>
                                </Link>
                                <IconButton disabled onClick={() => this.openConfirmModal(this.getIdValue(row))}>
                                    <DeleteIcon />
                                </IconButton>
                            </Stack>
                        )}
                        onPaginationChange={this.handlePageChange}
                        enableTopToolbar={false}
                        manualPagination={true}
                        autoResetPageIndex={false}
                        enableDensityToggle={false}
                        state={{
                            pagination: this.props.pagination
                        }} />
                </Box>
                {this.state.openConfirmModal && <ConfirmModal
                    cancelConfirmCallback={this.cancelConfirmModalCallback}
                    confirmCallback={this.acceptConfirmModal}
                    text={"Sei sicuro di voler procedere con l'eliminazione della serie?"}
                    textId={"st-delete-series-text"}
                />}
            </>)
    }
}
